import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';

@Directive({
	selector: '[conditionallyRequired][formControlName],[conditionallyRequired][formControl],[conditionallyRequired][ngModel]',
	providers: [ { provide: NG_VALIDATORS, useExisting: forwardRef(() => ConditionallyRequiredValidator), multi: true } ],
	standalone: false,
})
export class ConditionallyRequiredValidator implements Validator {

	@Input('conditionallyRequired') scrub: any;

	@Input('test-value')
	private testValue: any;

	@Input('skip-value')
	private skipValue: any;

	validate(control: AbstractControl): { [key: string]: any } {

		let returnValue: any = null;
		if (control) {
			const controlValue = control.value;

			if (typeof(controlValue) === 'undefined') {
				if (control.errors && control.errors.hasOwnProperty('conditionallyRequired')) {
					returnValue = { 'conditionallyRequired': control.errors['conditionallyRequired'] };
				}
			} else if (this.testValue !== this.skipValue) {
				if (controlValue === null) {
					returnValue = { conditionallyRequired: false };
				} else {
					const controlType: string = typeof controlValue;
					switch (controlType) {
						case 'string':
							if (controlValue === null || controlValue === undefined || controlValue.trim().length === 0) {
								returnValue = { conditionallyRequired: false };
							}
							break;
						case 'number':
							if (controlValue === 0) {
								returnValue = { conditionallyRequired: false };
							}
							break;
						case 'object':
							if (!controlValue) {
								returnValue = { conditionallyRequired: false };
							}
							break;
					}
				}
			}
		}
		return returnValue;
	}
}
